<template>
  <div id="coreData">
    <!-- 搜索 -->
    <div class="search">
      <el-select
        v-model="core.startCityCode"
        placeholder="全部城市"
        filterable
        clearable
        @change="searchChange"
      >
        <el-option
          v-for="val in cityList"
          :key="val.gaodeCityCode"
          :value="val.gaodeCityCode"
          :label="val.cityName"
        >
        </el-option>
      </el-select>
      <el-radio-group
        style="margin-left: 10px"
        size="mini"
        v-model="core.timeType"
        @change="searchChange"
      >
        <el-radio-button border :label="1">昨日</el-radio-button>
        <el-radio-button :label="7">最近7天</el-radio-button>
        <el-radio-button :label="30">最近30天</el-radio-button>
        <el-radio-button :label="180">最近半年</el-radio-button>
        <el-radio-button :label="365">最近一年</el-radio-button>
        <el-radio-button :label="0">从始至终</el-radio-button>
      </el-radio-group>
      <el-date-picker
        style="width: 240px; margin-left: 5px"
        v-model="core.date"
        type="daterange"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        size="mini"
        :picker-options="datePickerOptions"
        @change="dateChange"
      >
      </el-date-picker>

      <div style="margin-left: 10px">
        <el-button type="primary" @click="search">查询</el-button>
        <el-button @click="reset">重置</el-button>
      </div>
    </div>
    <!-- 订单趋势图表 -->
    <el-row style="margin-top: 16px">
      <el-col :span="24" style="height: 300px">
        <lineChart
          ref="orderLineChart"
          id="orderLineChart"
          :option="orderOption"
        ></lineChart>
      </el-col>
    </el-row>
    <!-- 交易趋势图表 -->
    <el-row style="margin-top: 16px">
      <el-col :span="24" style="height: 300px">
        <lineChart
          ref="tradeLineChart"
          id="tradeLineChart"
          :option="tradeOption"
        ></lineChart>
      </el-col>
    </el-row>
    <!-- 订单明细表格 -->
    <el-row style="margin-top: 16px">
      <div class="flex-between">
        <span>订单明细</span>
        <el-button type="text" @click="exportFn('HitchRideOrderNumStatistics')">导出明细</el-button>
      </div>
      <custom-table
        ref="orderTable"
        maxHeight="320"
        :customOptions="orderTable.options"
        :columns="orderTable.columns"
        :refreshShow="false"
      >
        <template slot-scope="{ item, row }">
          <template>{{ row[item.prop] ? row[item.prop] : 0 }}</template>
        </template>
      </custom-table>
    </el-row>
    <!-- 交易明细表格 -->
    <el-row style="margin-top: 16px">
      <div class="flex-between">
        <span>交易明细</span>
        <el-button type="text" @click="exportFn('HitchRideOrderAmountStatistics')">导出明细</el-button>
      </div>
      <custom-table
        ref="tradeTable"
        maxHeight="320"
        :customOptions="tradeTable.options"
        :columns="tradeTable.columns"
        :refreshShow="false"
      >
        <template slot-scope="{ item, row }">
          <template>{{ row[item.prop] ? row[item.prop] : 0 }}</template>
        </template>
      </custom-table>
    </el-row>

    <el-dialog
      class="dialog-export-modal"
      :visible.sync="exportShow"
      title="导出数据"
      width="600px"
      :close-on-click-modal="false"
    >
      <el-checkbox
        v-for="(item, index) in exportHeaders"
        v-model="item.isChecked"
        :key="index"
      >
        {{ item.title }}
      </el-checkbox>
      <template slot="footer">
        <el-button
          :loading="exportLoading"
          type="primary"
          @click="exportConfirmFn"
          >确定</el-button
        >
        <el-button @click="exportShow = false">取消</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import lineChart from "./components/lineChart.vue";
export default {
  name: "coreData",
  components: {
    lineChart,
  },
  data() {
    return {
      core: {
        startCityCode: null,
        timeType: 7,
        date: null,
      },
      orderOption: {
        title: {
          text: "订单趋势",
          textStyle: {
            fontSize: 14,
            fontWeight: "500",
          },
        },
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: ["创建订单", "参与抢单", "抢单成功", "完成订单"],
          bottom: "1%",
        },
        grid: {
          left: "4%",
          right: "4%",
          bottom: "9%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: [],
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            name: "创建订单",
            type: "line",
            data: [],
            smooth: true,
          },
          {
            name: "参与抢单",
            type: "line",
            data: [],
            smooth: true,
          },
          {
            name: "抢单成功",
            type: "line",
            data: [],
            smooth: true,
          },
          {
            name: "完成订单",
            type: "line",
            data: [],
            smooth: true,
          },
        ],
      },
      tradeOption: {
        title: {
          text: "交易趋势",
          textStyle: {
            fontSize: 14,
            fontWeight: "500",
          },
        },
        tooltip: {
          trigger: "axis",
        },
        legend: {
          data: ["创建订单", "参与抢单", "抢单成功", "完成订单"],
          bottom: "1%",
        },
        grid: {
          left: "4%",
          right: "4%",
          bottom: "9%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: [],
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            name: "创建订单",
            type: "line",
            data: [],
            smooth: true,
          },
          {
            name: "参与抢单",
            type: "line",
            data: [],
            smooth: true,
          },
          {
            name: "抢单成功",
            type: "line",
            data: [],
            smooth: true,
          },
          {
            name: "完成订单",
            type: "line",
            data: [],
            smooth: true,
          },
        ],
      },
      datePickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 3600 * 1000 * 24;
        },
      },

      orderTable: {
        options: {
          url: "/api/v1/manage/hitchRide/statistics/order",
          params: {
            page: 1,
            size: 15,
            startTime: null,
            endTime: null,
            startCityCode: null,
          },
        },
        columns: [
          { prop: "statisticsTime", label: "日期" },
          { prop: "createdNum", label: "创建订单(单)" },
          { prop: "confirmNum", label: "参与抢单(单)" },
          { prop: "confirmSucceedNum", label: "抢单成功(单)" },
          { prop: "finishNum", label: "完成订单(单)" },
          { prop: "cancelNum", label: "抢单前取消(单)" },
          { prop: "customerCancelNum", label: "抢单后乘客取消(单)" },
          { prop: "driverCancelNum", label: "司机取消(单)" },
          { prop: "systemCancelNum", label: "平台取消(单)" },
        ],
      },
      tradeTable: {
        options: {
          url: "/api/v1/manage/hitchRide/statistics/order",
          params: {
            page: 1,
            size: 15,
            startTime: null,
            endTime: null,
            startCityCode: null,
          },
        },
        columns: [
          { prop: "statisticsTime", label: "日期" },
          { prop: "createdAmount", label: "创建订单(元)" },
          { prop: "confirmAmount", label: "参与抢单(元)" },
          { prop: "confirmSucceedAmount", label: "抢单成功(元)" },
          { prop: "finishAmount", label: "完成订单(元)" },
          { prop: "cancelAmount", label: "抢单前取消(元)" },
          { prop: "customerCancelAmount", label: "抢单后乘客取消(元)" },
          { prop: "driverCancelAmount", label: "司机取消(元)" },
          { prop: "systemCancelAmount", label: "平台取消(元)" },
        ],
      },

      exportShow: false, //显示
      excelType: null, //表名
      exportHeaders: [], //表头
      exportLoading: false,
    };
  },
  computed: {
    ...mapGetters({
      cityList: "allCityListGetter",
    }),
  },
  watch: {
    "core.timeType": {
      immediate: true,
      handler(val) {
        this.setDate(val);
      },
    },
  },
  methods: {
    /**
     * 快捷选择日期
     * @param {Number} val 天数
     */
    setDate(val = 7) {
      if (val) {
        const nowDate = new Date().setHours(0, 0, 0, 0);
        const startTime = nowDate - 3600 * 1000 * 24 * val;
        const endTime = nowDate - 3600 * 1000 * 24; // 结束日期为昨天
        const end = new Date().setTime(endTime);
        const start = new Date().setTime(startTime);
        this.core.date = [start, end];
      } else if(val === 0) {
        this.core.date = null;
      }
    },
    /**
     * 设置订单表格参数
     */
    setOrderTableOptions() {
      this.orderTable.options.params.startCityCode = this.core.startCityCode;
      this.orderTable.options.params.startTime = this.core.date
        ? this.core.date[0] / 1000
        : null;
      this.orderTable.options.params.endTime = this.core.date
        ? this.core.date[1] / 1000
        : null;
    },
    /**
     * 设置交易表格参数
     */
    setTradeTableOptions() {
      this.tradeTable.options.params.startCityCode = this.core.startCityCode;
      this.tradeTable.options.params.startTime = this.core.date
        ? this.core.date[0] / 1000
        : null;
      this.tradeTable.options.params.endTime = this.core.date
        ? this.core.date[1] / 1000
        : null;
    },
    /**
     * 搜索
     */
    search() {
      this.getChartData();
      this.setOrderTableOptions();
      this.orderTable.options.params.page = 1;
      this.$refs.orderTable.listFn();
      this.setTradeTableOptions();
      this.tradeTable.options.params.page = 1;
      this.$refs.tradeTable.listFn();
    },
    /**
     * 重置
     */
    reset() {
      this.core.timeType = 7;
      this.setDate(7);
      this.core.startCityCode = null;
      this.search();
    },
    searchChange() {
      this.search();
    },
    dateChange(val) {
      console.log('val::: ', val);
      if(!val){
        this.core.timeType = 7;
        this.setDate(7);
      }else {
        this.core.timeType = null;
      }
      this.search();
    },
    // 获取图表数据
    async getChartData() {
      const { code, data } = await this.getData();
      if (code === 1) {
        this.orderOption.xAxis.data = data.map((item) => item.statisticsTime);
        this.orderOption.series[0].data = data.map((item) => item.createdNum);
        this.orderOption.series[1].data = data.map((item) => item.confirmNum);
        this.orderOption.series[2].data = data.map(
          (item) => item.confirmSucceedNum
        );
        this.orderOption.series[3].data = data.map((item) => item.finishNum);
        this.$refs.orderLineChart.initChart();
        this.tradeOption.xAxis.data = data.map((item) => item.statisticsTime);
        this.tradeOption.series[0].data = data.map(
          (item) => item.createdAmount
        );
        this.tradeOption.series[1].data = data.map(
          (item) => item.confirmAmount
        );
        this.tradeOption.series[2].data = data.map(
          (item) => item.confirmSucceedAmount
        );
        this.tradeOption.series[3].data = data.map((item) => item.finishAmount);
        this.$refs.tradeLineChart.initChart();
      }
    },
    /** 获取订单统计数据
     *
     * @param {Object} pageParams - 分页查询参数，包括页码和每页数量等
     * @return {Promise} 返回axios发出的GET请求的Promise对象，该Promise对象解析时包含订单统计数据
     */
    getData(pageParams) {
      const url = "/api/v1/manage/hitchRide/statistics/order";
      const params = {
        startCityCode: this.core.startCityCode,
        startTime: this.core.date ? this.core.date[0] / 1000 : null,
        endTime: this.core.date ? this.core.date[1] / 1000 : null,
        ...pageParams,
      };
      return this.$axios.get(url, params);
    },
    
    async exportFn(type) {
      this.excelType = type;
      this.exportShow = true;
      let exportHeaders = [];
      let url = "/api/v1/common/excel/header";
      let params = {
        excelType: type,
      };
      let data = await this.$axios.get(url, params);
      if (data && data.code === 1 && data.data) {
        exportHeaders = data.data.split(",").map(
          (item) =>
            (item = {
              isChecked: true,
              title: item,
            })
        );
      }
      this.exportHeaders = exportHeaders;
    },
    async exportConfirmFn() {
      const tableMap = new Map([
        ["HitchRideOrderNumStatistics", "orderTable"],
        ["HitchRideOrderAmountStatistics", "tradeTable"]
      ]);
      const tableName = tableMap.get(this.excelType);
      console.log(this.$refs[this.excelType]);

      if (this.$refs[tableName].table.total == 0) {
        this.$message.warning("导出数据不能为空");
        return;
      }
      let header = [];
      this.exportHeaders.forEach((item) => {
        if (item.isChecked) {
          header.push(item.title);
        }
      });
      if (header.length < 1) {
        this.$message.warning("请选择导出表头");
        return;
      }
      this.exportLoading = true;
      let params = {
        startCityCode: this.core.startCityCode,
        startTime: this.core.date ? this.core.date[0] / 1000 : null,
        endTime: this.core.date ? this.core.date[1] / 1000 : null,
      };
      params.excelType = this.excelType;
      params.header = header.join(",");
      let data = await this.$axios.get("/api/v1/common/excel", params);
      this.exportLoading = false;
      if (data && data.code === 1) {
        this.exportShow = false;
        this.$store.dispatch("acExcelForm", data.data);
        this.$mqtt.newTopic({
          tpc: data.data.topic,
          opt: {
            qos: 1,
          },
        });
      }
    },
  },
  mounted() {
    this.getChartData();
      this.setOrderTableOptions();
      this.orderTable.options.params.page = 1;
      this.setTradeTableOptions();
      this.tradeTable.options.params.page = 1;
  },
};
</script>

<style lang="less">
#coreData {
  padding-bottom: 16px;
  .search {
    display: flex;
    align-items: center;
  }
  .condition {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 10px;

    & > div > * {
      margin-right: 30px;
      vertical-align: middle;
    }
  }
}
</style>
